<script>
import useVuelidate from '@vuelidate/core';
import {required} from '@vuelidate/validators';

/* COMPOSANTS */
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';
import AkFormSubmitted from '@components/general/AkFormSubmitted';
import AkInputText from '@components/v2/input/AkInputText';
import AkLoader from '@components/general/AkLoader.vue';

/* MIXINS */
import loaderMixin from '@mixins/loaderMixin';
import messageMixin from '@mixins/messageMixin';
import otaTokenPlatformConst from '@mixins/const/otaTokenPlatformConst';
import randomRef from '@mixins/randomRef';

/* SERVICES */
import otaTokenService from '@services/otaTokenService';

export default {
  components: {AkButtonValidation, AkFormSubmitted, AkInputText, AkLoader},
  mixins: [loaderMixin, messageMixin, otaTokenPlatformConst, randomRef],
  setup() {
    return {v$: useVuelidate()};
  },
  emits: ['create-done'],
  props: {
    otaTokenId: {
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      submitted: false,
      otaToken: {},
    };
  },
  validations() {
    return {
      otaToken: {
        label: {required},
      },
    };
  },
  mounted() {
    this.$refs.loader.load();
    otaTokenService
      .otaToken(this.otaTokenId)
      .then((data) => {
        this.otaToken = data;
      })
      .finally(() => {
        this.$refs.loader.hide();
      });
  },
  methods: {
    addSubError(content) {
      this.messages = [];
      this.messages.push({
        id: this.generateUUID(),
        closable: true,
        icon: 'ga-icon ga-filled_cross text-3xl text-white',
        severity: 'error',
        content: content,
        life: 10000,
      });
    },
    update() {
      this.messages = [];
      this.$refs.btnUpdate.load();
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$error) {
        this.$refs.btnUpdate.init();
        return;
      }
      otaTokenService
        .update(this.otaToken)
        .then((data) => {
          this.$refs.btnUpdate.init();
          this.success('Le libellé a bien été mis à jour');
          this.submitted = false;
          this.otaToken = data;
          this.$emit('create-done');
        })
        .catch((e) => {
          this.$refs.btnUpdate.init();
          this.addSubError(e.response?.data?.error ?? 'Une erreur est survenue');
          this.submitted = false;
        });
    },
  },
};
</script>

<template>
  <AkLoader ref="loader" :scale="2" message="Chargement en cours...">
    <template #content>
      <Message
        class="mb-2"
        v-for="msg of messages"
        :key="msg.id"
        :closable="msg.closable"
        :icon="msg.icon"
        :severity="msg.severity"
        :life="msg.life">
        {{ msg.content }}
      </Message>
      <AkFormSubmitted :submitted="submitted" reference="form" @submit="update()">
        <div class="flex flex-col gap-2">
          <div class="flex flex-col gap-1 mb-1">
            <span class="text-grey-500 text-sm">Plateforme</span>
            <span class="font-medium text-grey-900">{{ displayForOtaTokenPlatformConst(otaToken.platform) }}</span>
          </div>
          <div class="flex flex-col gap-1 mb-1">
            <span class="text-grey-500 text-sm">ID du compte</span>
            <span class="font-medium text-grey-900 break-words">{{ otaToken.otaAccountId }}</span>
          </div>
          <AkInputText v-model="otaToken.label" label="Libellé du compte" :validator="v$.otaToken.label" />
        </div>
        <div class="mt-2 flex justify-end">
          <AkButtonValidation ref="btnUpdate" @action="update" label="Mettre à jour" />
        </div>
      </AkFormSubmitted>
    </template>
  </AkLoader>
</template>
